<input
  class="profile-search-input"
  type="search"
  aria-label="Search profile"
  nz-input
  [ngModel]="text()"
  [nzAutocomplete]="profileAutocomplete"
  [nzSize]="size()"
  [placeholder]="placeholder()"
  (ngModelChange)="onTextChange($event)" />

<nz-autocomplete
  #profileAutocomplete
  [nzBackfill]="false"
  [nzDefaultActiveFirstOption]="true"
  (selectionChange)="onOptionSelected($event)">
  @for (option of options(); track $index) {
    <nz-auto-option
      [nzLabel]="text()"
      [nzValue]="option">
      @if (option.kind === 'profile') {
        <span class="profile-search-option">
          <span class="profile-search-title">{{ option.profile.title }}</span>
          <span class="profile-search-meta">
            #{{ option.profile.id }}
            @if (optionNote()(option.profile); as note) {
              · {{ note }}
            }
          </span>
        </span>
      } @else {
        <span class="profile-search-option">
          <span class="profile-search-title">Open profile with ID {{ option.id }}</span>
        </span>
      }
    </nz-auto-option>
  }
  @if (!searching() && text().trim().length >= 3 && options().length === 0) {
    <nz-auto-option
      nzDisabled
      [nzLabel]="text()"
      [nzValue]="null">
      No profile found
    </nz-auto-option>
  }
</nz-autocomplete>
